export const breakpoints = {
  mobile: 'min-width: 0px',
  tablet: 'min-width: 500px',
  desktop: 'min-width: 1024px',
  desktopWide: 'min-width: 1200px',
};
